import { useFormContext, useWatch } from 'react-hook-form';

import { Checkbox } from 'shared';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { CoachingMode } from 'features/participants/config/types';
import {
  LATE_STATUS_TIME_BY_COACHING_MODE,
  SESSION_ATTENDANCE_STATUS,
} from 'features/sessions/config';

import { Typography } from 'shared/components/Typography';

export const SessionsFormLateStatus = () => {
  const { register } = useFormContext();

  const coachingMode = useWatch({ name: 'coachingMode' }) as CoachingMode;
  const attendance = useWatch({
    name: 'attendance',
  });

  if (attendance !== SESSION_ATTENDANCE_STATUS.ATTENDED) {
    return null;
  }

  return (
    <>
      <Spacer size="lg zr zr" />
      <Checkbox {...register('isLate')} data-testid="session-late-checkbox">
        <Typography>
          Late {LATE_STATUS_TIME_BY_COACHING_MODE[coachingMode]}+ minutes
        </Typography>
      </Checkbox>
    </>
  );
};
